import React, {useState} from 'react';
import Container from '../Container';
import Content from '../Content';
import Header from '../navbar/Header';
import Navbar from '../navbar/Navbar';
import TaskForm from './TaskForm';

function TaskFormContainer(props) {
   const [refresh, setRefresh] = useState(true);
    return (
       <Container>
          <Navbar/>

          <Content>
          <Header/>

            <TaskForm refresh={refresh} setRefresh={setRefresh}/>
          </Content>
       </Container>
    );
}

export default TaskFormContainer;